var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOmniChannel = function SvgOmniChannel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "omni-channel_svg2__a",
    x1: 37.39,
    x2: 138.28,
    y1: 159.94,
    y2: 21.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni-channel_svg2__a",
    id: "omni-channel_svg2__b",
    x1: 7.78,
    x2: 108.68,
    y1: 138.32,
    y2: 0.16
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni-channel_svg2__a",
    id: "omni-channel_svg2__c",
    x1: 44.6,
    x2: 145.49,
    y1: 165.21,
    y2: 27.04
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni-channel_svg2__a",
    id: "omni-channel_svg2__d",
    x1: 20.68,
    x2: 121.58,
    y1: 147.74,
    y2: 9.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni-channel_svg2__a",
    id: "omni-channel_svg2__e",
    x1: 1.43,
    x2: 102.33,
    y1: 133.69,
    y2: -4.48
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni-channel_svg2__a",
    id: "omni-channel_svg2__f",
    x1: 14.65,
    x2: 115.54,
    y1: 143.34,
    y2: 5.17
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni-channel_svg2__a",
    id: "omni-channel_svg2__g",
    x1: 84.43,
    x2: 185.32,
    y1: 194.29,
    y2: 56.13
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni-channel_svg2__a",
    id: "omni-channel_svg2__h",
    x1: 73.49,
    x2: 174.38,
    y1: 186.3,
    y2: 48.14
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni-channel_svg2__a",
    id: "omni-channel_svg2__i",
    x1: 62.79,
    x2: 163.68,
    y1: 178.49,
    y2: 40.33
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni-channel_svg2__a",
    id: "omni-channel_svg2__j",
    x1: 102.09,
    x2: 202.99,
    y1: 207.19,
    y2: 69.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni-channel_svg2__a",
    id: "omni-channel_svg2__k",
    x1: 88.88,
    x2: 189.77,
    y1: 197.54,
    y2: 59.38
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#omni-channel_svg2__a",
    id: "omni-channel_svg2__l",
    x1: 67.31,
    x2: 168.2,
    y1: 181.79,
    y2: 43.63
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M83.33 33.33c1.84 0 3.33-1.49 3.33-3.33V10c0-1.83 1.5-3.33 3.33-3.33h80c1.83 0 3.33 1.5 3.33 3.33v40c0 1.83-1.5 3.33-3.33 3.33h-6.67c-1.84 0-3.33 1.49-3.33 3.33v10.79l-10.77-12.93c-.63-.77-1.57-1.2-2.56-1.2h-10c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h8.44l15.67 18.8a3.32 3.32 0 0 0 3.69 1c1.32-.48 2.2-1.73 2.2-3.13V59.98h3.33c5.51 0 10-4.49 10-10V10C180 4.49 175.51 0 170 0H90c-5.51 0-10 4.49-10 10v20c0 1.84 1.49 3.33 3.33 3.33",
    style: {
      strokeWidth: 0,
      fill: "url(#omni-channel_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50 113.33h-6.67c-1.05 0-2.04.49-2.67 1.33l-14 18.67v-16.67c0-1.84-1.49-3.33-3.33-3.33H10c-1.83 0-3.33-1.5-3.33-3.33V50c0-1.83 1.5-3.33 3.33-3.33h106.67c1.83 0 3.33 1.5 3.33 3.33v26.67c0 1.84 1.49 3.33 3.33 3.33s3.33-1.49 3.33-3.33V50c0-5.51-4.49-10-10-10H10C4.49 40 0 44.49 0 50v60c0 5.51 4.49 10 10 10h10v23.33c0 1.43.92 2.71 2.28 3.17.35.11.7.17 1.05.17 1.03 0 2.03-.47 2.67-1.33l19-25.33h5c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33Z",
    style: {
      strokeWidth: 0,
      fill: "url(#omni-channel_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160 30c0-1.84-1.49-3.33-3.33-3.33H130c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h26.67c1.84 0 3.33-1.49 3.33-3.33",
    style: {
      strokeWidth: 0,
      fill: "url(#omni-channel_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.67 26.67c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h20c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33z",
    style: {
      strokeWidth: 0,
      fill: "url(#omni-channel_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.33 86.67C21.49 86.67 20 88.16 20 90s1.49 3.33 3.33 3.33h20c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33z",
    style: {
      strokeWidth: 0,
      fill: "url(#omni-channel_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.67 76.67c0-1.84-1.49-3.33-3.33-3.33H23.33c-1.84 0-3.33 1.49-3.33 3.33S21.49 80 23.33 80h80c1.84 0 3.33-1.49 3.33-3.33Z",
    style: {
      strokeWidth: 0,
      fill: "url(#omni-channel_svg2__f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190 86.67H70c-5.51 0-10 4.49-10 10v66.67c0 5.51 4.49 10 10 10h85l19 25.33a3.32 3.32 0 0 0 2.67 1.33c.35 0 .71-.06 1.05-.17a3.35 3.35 0 0 0 2.28-3.17v-23.33h10c5.51 0 10-4.49 10-10V96.66c0-5.51-4.49-10-10-10Zm3.33 76.66c0 1.83-1.5 3.33-3.33 3.33h-13.33c-1.84 0-3.33 1.49-3.33 3.33v16.67l-14-18.67a3.33 3.33 0 0 0-2.67-1.33H70c-1.83 0-3.33-1.5-3.33-3.33V96.66c0-1.83 1.5-3.33 3.33-3.33h120c1.83 0 3.33 1.5 3.33 3.33z",
    style: {
      strokeWidth: 0,
      fill: "url(#omni-channel_svg2__g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.67 146.67H83.34c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h33.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      strokeWidth: 0,
      fill: "url(#omni-channel_svg2__h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.33 140h20c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33h-20c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      strokeWidth: 0,
      fill: "url(#omni-channel_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.67 120H150c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33h26.67c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      strokeWidth: 0,
      fill: "url(#omni-channel_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150 133.33h-33.33c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33H150c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33",
    style: {
      strokeWidth: 0,
      fill: "url(#omni-channel_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.33 126.67h53.33c1.84 0 3.33-1.49 3.33-3.33s-1.49-3.33-3.33-3.33H83.33c-1.84 0-3.33 1.49-3.33 3.33s1.49 3.33 3.33 3.33",
    style: {
      fill: "url(#omni-channel_svg2__l)",
      strokeWidth: 0
    }
  }));
};
export default SvgOmniChannel;